import { render, staticRenderFns } from "./MatterNoteList.vue?vue&type=template&id=03a2bb10&"
import script from "./MatterNoteList.vue?vue&type=script&lang=js&"
export * from "./MatterNoteList.vue?vue&type=script&lang=js&"
import style0 from "./MatterNoteList.vue?vue&type=style&index=0&id=03a2bb10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports